var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Styles from './DialogMessage.less';
import Icon from '@cvent/nucleus-icon';
import { resolve, select } from '@cvent/nucleus-dynamic-css';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';
import Button from 'nucleus-core/buttons/Button';
export default function DialogMessage(_a) {
    var { type, title, message, onBackClick, translate, backButtonText } = _a, rest = __rest(_a, ["type", "title", "message", "onBackClick", "translate", "backButtonText"]);
    const iconClass = `${Styles.icon} ${Styles[type]}`;
    return (React.createElement("div", Object.assign({ className: Styles.container }, resolveTestId(rest)),
        React.createElement(Icon, Object.assign({}, injectTestId('icon'), { icon: type === 'success' ? 'check' : 'error', modifier: iconClass })),
        React.createElement("h2", Object.assign({}, resolve(rest, 'title'), injectTestId('title')), title),
        React.createElement("h4", Object.assign({}, resolve(rest, 'subTitle'), injectTestId('subtitle')), message),
        onBackClick && (React.createElement("div", { className: Styles.backButtonContainer },
            React.createElement(Button, Object.assign({}, injectTestId('link'), select(rest, 'backButton'), { kind: "backButton", onClick: onBackClick, title: `< ${backButtonText || translate('EventWidgets_AlreadyRegistered_BackButton__resx')}` }))))));
}
